import type {
	PermissionInfo,
	ProjectSidebarNavInfo,
} from '@atlassian/jira-navigation-apps-resources/src/services/sidebar/project-sidebar-navigation/types.tsx';

const isProjectOrJiraAdmin = (permissionInfo: PermissionInfo): boolean =>
	permissionInfo.isAdmin || permissionInfo.projectPermissionsQueried.ADMINISTER_PROJECTS || false;

export const getCanEditShortcuts = (data: ProjectSidebarNavInfo): boolean => {
	const {
		projectType,
		jiraWorkManagementNavData,
		jiraSoftwareNavData,
		jiraServiceManagementNavData,
		jiraProductDiscoveryNavData,
	} = data || {};

	switch (projectType) {
		case 'jira_work_management':
			return jiraWorkManagementNavData?.permissionInfo
				? isProjectOrJiraAdmin(jiraWorkManagementNavData.permissionInfo)
				: false;
		case 'jira_software':
			return jiraSoftwareNavData?.permissionInfo
				? isProjectOrJiraAdmin(jiraSoftwareNavData.permissionInfo)
				: false;
		case 'jira_service_management':
			return jiraServiceManagementNavData?.permissionInfo
				? isProjectOrJiraAdmin(jiraServiceManagementNavData.permissionInfo)
				: false;
		case 'jira_product_discovery':
			return jiraProductDiscoveryNavData?.permissionInfo
				? isProjectOrJiraAdmin(jiraProductDiscoveryNavData.permissionInfo)
				: false;
		case null:
			return false;
		default:
			return false;
	}
};
